export default "__VITE_ASSET__cbMJUYiE__"